import styled, { css } from "styled-components";
import { color, units } from "@m/alchemy-theme";
import { FocusList } from "../utilities/focus-list/FocusList";
export const ActionList = styled(FocusList).attrs({
    elementType: "ul",
    itemSelector: "[data-actionlist-focusitem]",
    keyboardDirection: "vertical"
}) `
  + ul {
    border-top: 12px solid ${color("line")};
  }
  ${({ hasIcons, layout }) => hasIcons &&
    layout === "start" &&
    css `
      li > * {
        padding-left: ${units(4)};
        text-align: left;
      }

      ul {
        padding-left: 0;
      }
    `};

  ${({ hasIcons, layout }) => hasIcons &&
    layout === "end" &&
    css `
      li > * {
        padding-right: ${units(4)};
        text-align: right;
      }

      ul {
        padding-right: 0;
      }
    `};
`;
